import { useEffect } from 'react';

export function useOutsideClick(refs, callback) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (!Array.isArray(refs)) {
        return;
      }

      const isOutsideClick = refs.every((ref) => {
        if (typeof ref.current === 'undefined' || ref.current === null) {
          return false;
        }
        return !ref.current.contains(event.target);
      });

      if (isOutsideClick) {
        callback();
      }
    }

    window.addEventListener('mousedown', handleClickOutside);
    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refs]);
}
